<!--<div class="atlas-navbar__accounts-form__title">{{ 'VBC_NOTIFICATIONS.TITLE' | translate }}</div>-->

<atlas-notification-accounts-form-settings
  [partnerId]="partnerId"
  (onError)="onError.emit($event)"
  [accountGroupId]="accountGroupId$ | async"
></atlas-notification-accounts-form-settings>
